// Replacing Unibabel package
function utf8ToBinaryString ( str ) {
    var escstr = encodeURIComponent(str);
    // replaces any uri escape sequence, such as %0A,
    // with binary escape, such as 0x0A
    var binstr = escstr.replace(/%([0-9A-F]{2})/g, function ( match, p1 ) {
        return String.fromCharCode(parseInt(p1, 16));
    });

    return binstr;
}

function binaryStringToBuffer(binstr) {
	let buffer;

	if ('undefined' !== typeof Uint8Array) {
		buffer = new Uint8Array(binstr.length);
	} else {
		buffer = [];
	}

	Array.prototype.forEach.call(binstr, function (ch, i) {
		buffer[i] = ch.charCodeAt(0);
	});

	return buffer;
}

function utf8ToBuffer(str) {
	const binstr = utf8ToBinaryString(str);
	const buf = binaryStringToBuffer(binstr);
	return buf;
}

function bufferToBinaryString(buf) {
	const binstr = Array.prototype.map.call(buf, function (ch) {
		return String.fromCharCode(ch);
	}).join('');

	return binstr;
}

function bufferToBase64(arr) {
	const binstr = bufferToBinaryString(arr);
	return btoa(binstr);
}


//=============================================================================
//
// A Base64 encoder that delegates to UniBabel
//
//=============================================================================
class Base64Encoder {

    //=============================================================================
    // Given a Unicode string, returns a base64-encoded rendition of that string.
    //=============================================================================
    static b64EncodeUnicode(str) {
        return window.btoa(encodeURIComponent(str).replace(/%([0-9A-Fa-f]{2})/g, function (match, p1) {
            return String.fromCharCode(`0x${p1}`);
        }));
    }

	//=============================================================================
	// Given a string, returns a base64-encoded rendition of that string,
	// or returns undefined if the input argument is not a string
	//=============================================================================
	static encodeToString( str ) {
		if (typeof str === 'string' ) {
			const buffer = utf8ToBuffer( str );
			return bufferToBase64( buffer );
		}
		return undefined;
	}

	//=============================================================================
	// Given a string, returns a base64-encoded rendition of that string,
	// or returns undefined if the input argument is not a string
	//=============================================================================
	static encodeToArray( str ) {
		if (typeof str === 'string' ) {
			const uint8Array = window.Unibabel.strToUtf8Arr( str );
			return window.Unibabel.arrToBase64( uint8Array );
		}
		return undefined;
	}
}

export default Base64Encoder;

